import { Link } from '@tanstack/react-router';

export function FaqPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-display font-bold text-white mb-8 text-center">
        Frequently Asked Questions
      </h1>

      <div className="space-y-4">
        <div className="card">
          <h2 className="text-lg font-semibold text-white mb-2">How does DreamPaths work?</h2>
          <p className="text-dream-300">
            You enter your dream when you wake up, we&rsquo;ll help you explore the ways it could be
            meaningful.
          </p>
        </div>

        <div className="card">
          <h2 className="text-lg font-semibold text-white mb-2">How does DreamPaths analyze dreams?</h2>
          <p className="text-dream-300">
            Your dream is processed to examine various potential meanings and interpretations to give you a
            variety of lenses and perspectives to spark insightful connections. This information can then be
            cross-compared with your prior dreams to identify trends and patterns.
          </p>
        </div>

        <div className="card">
          <h2 className="text-lg font-semibold text-white mb-2">Who can access these insights?</h2>
          <p className="text-dream-300">
            Your dream readings are private unless you choose to share them with others by making them
            available to the public for community research.
          </p>
        </div>

        <div className="card">
          <h2 className="text-lg font-semibold text-white mb-2">How does community dream research work?</h2>
          <div className="space-y-3">
            <p className="text-dream-300">
              When we share our dreams publicly with each other this allows us to run comparative analysis
              that may reveal patterns across people in distant places which tell a collective story.
            </p>
            <p className="text-dream-300">
              Public dreams are available to view and search by DreamPaths members as well as participate in
              shaping the research with us.
            </p>
          </div>
        </div>

        <div className="card">
          <h2 className="text-lg font-semibold text-white mb-2">Who operates DreamPaths?</h2>
          <p className="text-dream-300">
            DreamPaths was founded by{' '}
            <a
              href="https://getauthentic.com"
              className="text-dream-200 underline hover:text-white"
              target="_blank"
              rel="noreferrer"
            >
              Authentic Creative
            </a>
            , a venture studio in Topanga, California investing in the expansion of consciousness through
            introspective and contemplative technologies.
          </p>
        </div>

        <div className="card">
          <h2 className="text-lg font-semibold text-white mb-2">
            Is there any kind of mental health benefit?
          </h2>
          <p className="text-dream-300 mb-2">Users have reported:</p>
          <ul className="list-disc list-inside space-y-1 text-dream-300 mb-3">
            <li>A significant increase in the ability to remember dreams after waking up.</li>
            <li>Improved ability to remember them for longer after waking up.</li>
            <li>Improved lucidity in dreams and ability to explore their dreams actively while having them.</li>
          </ul>
          <p className="text-dream-300">
            This website is for entertainment, mystical and dare we say spiritual experiences only. Nothing
            here is medical advice.
          </p>
        </div>

        <div className="card">
          <h2 className="text-lg font-semibold text-white mb-2">How do I delete my account?</h2>
          <p className="text-dream-300">
            If you are logged in you can delete your account from your{' '}
            <Link to="/profile" className="text-dream-200 underline hover:text-white">
              profile page
            </Link>
            .
          </p>
        </div>

        <div className="card">
          <h2 className="text-lg font-semibold text-white mb-2">Bug!?</h2>
          <p className="text-dream-300">
            If you find a bug and want to report it, please send it to{' '}
            <a
              href="mailto:bugreport@getauthentic.com"
              className="text-dream-200 underline hover:text-white"
            >
              bugreport@getauthentic.com
            </a>
            . Thank you!
          </p>
        </div>
      </div>
    </div>
  );
}
